const externalService = window.APP.apiURL

export default {
  retrieveCurrentAgent() {
    return this.get(`${externalService}/agents/me`, 'user', { responseErrorJson: true })
  },
  retrieveDanaProfile() {
    return this.get(`${externalService}/_exclusive/e-wallets/dana/profile`, 'user', {
      responseErrorJson: true,
    })
  },
  getQrisCode() {
    return this.get(`${externalService}/_exclusive/mitra-qr/qris`, 'user', {
      responseErrorJson: true,
    })
  },
  // getMixedDanaActivationType() {
  //  return this.get(`${externalService}/_exclusive/mitra/me/flags`, 'user', {
  //    responseErrorJson: true,
  //  });
  // },
  // retrieveAllowlistMeFeature(feature) {
  //  return this.get(`${externalService}/_exclusive/mitra/me/allowlists/${feature}`, 'user', {
  //    responseErrorJson: true,
  //  });
  // },
}
